<template>
  <v-card class="pb-1" min-width="300" light>
    <v-system-bar dark color="grey darken-1" height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      {{ groupe.nom_groupe }}

      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>

    <v-card-text>
      <template>
        <v-card flat class="ma-0 pa-0">
          <v-tabs v-model="model">
            <v-tab href="#menages"> Ménages ({{ menages.length }}) </v-tab>
            <v-tab href="#membres">
              Membres ({{ MembresDugroupe.length }})
            </v-tab>
            <v-tab href="#inactifs" >
              Membres Inactifs ({{ MembresDuGroupeInactifs.length }})
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="model">
            <v-tab-item value="menages">
              <v-card flat>
                <v-card-text v-if="groupe.menageGenerated">
                  <v-data-table
                    :headers="headers"
                    :items="menages"
                    :items-per-page="100"
                  >
                    <template v-slot:item.tags="{ item }">
                      {{ menages.indexOf(item) + 1 }}
                    </template>
                    <template v-slot:item.membres="{ item }">
                      <membresDeMenage :key="item.id" :menage="item.id" />
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-card-text v-else>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        class="mx-2"
                        :loading="loading"
                        dark
                        small
                        color="primary"
                        @click="loadGenerateMenages()"
                      >
                        Générer ménages à partir des membres
                        <v-icon dark>
                          mdi-account-multiple-plus
                        </v-icon>
                      </v-btn>
                    </template>
                    <span> Générer ménages à partir des membres</span>
                  </v-tooltip>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="membres">
              <v-card flat>
                <v-card-text>
                  <v-layout row justify-center>
                    <v-dialog v-model="editDialog" max-width="350">
                      <v-card>
                        <v-card-title>
                          <span class="headline">Editer membre</span>
                        </v-card-title>
                        <v-card-text>
                          <v-form ref="form">
                            <v-container fluid>
                              <v-row no-gutters="">
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="editedItem.nom"
                                    dense
                                    label="Nom"
                                    prepend-icon="person"
                                  ></v-text-field>
                                </v-col>

                                <v-col cols="12">
                                  <v-radio-group
                                    v-model="editedItem.actif_dans_groupe"
                                    row
                                  >
                                    <v-radio
                                      label="Actif"
                                      :value="parseInt(1)"
                                    ></v-radio>
                                    <v-radio
                                      label="Inactif"
                                      :value="parseInt(0)"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                                <v-col cols="12">
                                  <v-radio-group v-model="editedItem.sexe" row>
                                    <v-radio
                                      label="Masculin"
                                      :value="parseInt(1)"
                                    ></v-radio>
                                    <v-radio
                                      label="Féminin"
                                      :value="parseInt(0)"
                                    ></v-radio>
                                  </v-radio-group>
                                </v-col>
                                <v-col cols="12">
                                  <v-text-field
                                    v-model="editedItem.annee_naissance"
                                    dense
                                    label="Année de naissance"
                                    prepend-icon="person"
                                    required
                                    type="number"
                                    placeholder="1970"
                                  ></v-text-field>
                                </v-col>
                                <v-col class="my-0" cols="12">
                                  <v-autocomplete
                                    v-model="code_menage_selected"
                                    dense
                                    :items="menages"
                                    label="Ménage"
                                    outlined
                                    item-value="code_menage"
                                    item-text="nomMembrePrincipal"
                                  ></v-autocomplete>
                                </v-col>
                              </v-row>
                            </v-container>
                          </v-form>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            rounded
                            color="info"
                            @click.native="closeDialog()"
                            >Annuler</v-btn
                          >
                          <v-btn
                            rounded
                            color="primary"
                            @click.native="updateMembre()"
                            >Mettre à jour</v-btn
                          >
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-layout>
                  <dialogNewMembre :groupe="groupe" :id="$route.params.id" />

                  <div
                    class="ma-4"
                    justify="center"
                    align="center"
                    v-if="
                      user.role === 'regionalFull' ||
                      user.role === 'regionalReadOnly'
                    "
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          outlined
                          small
                          fab
                          dark
                          class="transparent red mr-4"
                          @click="repairTousLesMembredugroupe()"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>mdi-alert-outline</v-icon>
                        </v-btn>
                      </template>
                      <span>Réparer tous les membres</span>
                    </v-tooltip>

                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          small
                          fab
                          dark
                          class="green red"
                          @click="gotoAnimateur()"
                        >
                          <v-icon>mdi-account</v-icon>
                        </v-btn>
                      </template>
                      <span>Détails de l'animateur</span>
                    </v-tooltip>
                  </div>
                  <v-card
                    v-for="(item, index) in MembresDugroupe"
                    :key="index"
                    class="grey lighten-3"
                    v-bind:class="{
                      'grey lighten-1': item.actif_dans_groupe == 0,
                    }"
                  >
                    <div v-if="item.actif_dans_groupe == 0" class="text-right">
                      <v-chip
                        class="ma-2"
                        color="pink"
                        label
                        text-color="white"
                      >
                        <v-icon left>
                          mdi-label
                        </v-icon>
                        Inactif
                      </v-chip>
                    </div>
                    <v-container class="mb-2">
                      <v-row>
                        <v-col>
                          <div class="text-h6">{{ item.nom }}</div>

                          <div>
                            {{
                              calculate_age(
                                new Date(item.annee_naissance, 1, 1)
                              )
                            }}
                            ans
                          </div>
                          <div v-if="item.sexe !== 1 || item.sexe !== 0">{{ getSexe(item.sexe) }}</div>
                          <div v-else class="danger white--text">{{ getSexe(item.sexe) }}</div>
                          <div
                            v-if="
                              user.role === 'regionalFull' ||
                              user.role === 'regionalReadOnly'
                            "
                          >
                            {{ item.id }}
                          </div>

                          <div v-if="item.code_menage">
                            Membres du ménage :
                            <membresDeMenage
                              :key="item.code_menage"
                              :menage="item.code_menage"
                            />
                          </div>
                        </v-col>

                        <v-col>
                          <div class="text-right">
                            <checkMenage
                              :idMenage="item.code_menage"
                              :key="item.code_menage"
                              :membre="item"
                              :groupe="groupe"
                            />
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  v-if="
                                    groupe.responsable != item.id_responsable
                                  "
                                  color="red darken-2 mr-4"
                                  fab
                                  class="elevation-0"
                                  dark
                                  @click="repairMembre(item)"
                                >
                                  <v-icon>mdi-alert-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Réparer membre</span>
                            </v-tooltip>

                            <v-btn
                              color="grey lighten-2 mr-4"
                              fab
                              class="elevation-0"
                              @click="showEditDialog(item)"
                            >
                              <v-icon>mdi-account-edit-outline</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="
                                user.role === 'regionalFull' ||
                                user.role === 'regionalReadOnly'
                              "
                              color="danger"
                              fab
                              dark
                              class="elevation-0"
                              @click="deleteMembre(item)"
                            >
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="inactifs" v-if="
                      user.role === 'regionalFull' ||
                      user.role === 'regionalReadOnly'
                    ">
              <v-card flat>
                <v-card-text>
                  <v-card
                    v-for="(item, index) in MembresDuGroupeInactifs"
                    :key="index"
                    class="grey lighten-3"
                    v-bind:class="{
                      'grey lighten-1': item.actif_dans_groupe == 0,
                    }"
                  >
                    <div v-if="item.actif_dans_groupe == 0" class="text-right">
                      <v-chip
                        class="ma-2"
                        color="pink"
                        label
                        text-color="white"
                      >
                        <v-icon left>
                          mdi-label
                        </v-icon>
                        Inactif
                      </v-chip>
                    </div>
                    <v-container class="mb-2">
                      <v-row>
                        <v-col>
                          <div class="text-h6">{{ item.nom }}</div>

                          <div>
                            {{
                              calculate_age(
                                new Date(item.annee_naissance, 1, 1)
                              )
                            }}
                            ans
                          </div>
                          <div>{{ getSexe(item.sexe) }}</div>
                          <div
                            v-if="
                              user.role === 'regionalFull' ||
                              user.role === 'regionalReadOnly'
                            "
                          >
                            {{ item.id }}
                          </div>

                          <div v-if="item.code_menage">
                            Membres du ménage :
                            <membresDeMenage
                              :key="item.code_menage"
                              :menage="item.code_menage"
                            />
                          </div>
                        </v-col>

                        <v-col>
                          <div class="text-right">
                            <checkMenage
                              :idMenage="item.code_menage"
                              :key="item.code_menage"
                              :membre="item"
                              :groupe="groupe"
                            />
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  v-if="
                                    groupe.responsable != item.id_responsable
                                  "
                                  color="red darken-2 mr-4"
                                  fab
                                  class="elevation-0"
                                  dark
                                  @click="repairMembre(item)"
                                >
                                  <v-icon>mdi-alert-outline</v-icon>
                                </v-btn>
                              </template>
                              <span>Réparer membre</span>
                            </v-tooltip>

                            <v-btn
                              color="grey lighten-2 mr-4"
                              fab
                              class="elevation-0"
                              @click="showEditDialog(item)"
                            >
                              <v-icon>mdi-account-edit-outline</v-icon>
                            </v-btn>
                            <v-btn
                              v-if="
                                user.role === 'regionalFull' ||
                                user.role === 'regionalReadOnly'
                              "
                              color="danger"
                              fab
                              dark
                              class="elevation-0"
                              @click="deleteMembre(item)"
                            >
                              <v-icon>mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </div>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  mounted() {
    this.GetMembresDuGroupe(this.$route.params.id);
    this.GetMembresDuGroupeInactifs(this.$route.params.id);
    this.GetMenagesDuGroupe(this.$route.params.id);
    this.getDetailsAnimateur();
  },
  data() {
    return {
      loading: false,
      editDialog: false,
      editedItem: {},
      detailsAnimateur: {},
      code_menage_selected: false,
      selectRules: [(v) => !!v || "Veuillez sélectionner une valeur"],
      model: "membres",
      headers: [
        {
          text: "N°",
          align: "start",
          value: "tags",
        },
        { text: "Membres", value: "membres" },
      ],
    };
  },
  components: {
    etapesEffectives: require("@/components/groupes/etapesEffectives.vue")
      .default,
    vcol: require("@/components/groupes/col.vue").default,
    detailCampagne: require("@/components/groupes/detailCampagne.vue").default,
    dialogNewMembre: require("@/components/groupes/dialogNewMembre.vue")
      .default,
    dialogNewCampagne: require("@/components/groupes/dialogNewCampagne.vue")
      .default,
    dialogNewCycleGec: require("@/components/groupes/dialogNewCycleGec.vue")
      .default,
    dialogNewFormation: require("@/components/groupes/dialogNewFormation.vue")
      .default,
    dialogNewIntrant: require("@/components/groupes/dialogNewIntrant.vue")
      .default,
    membresDeMenage: require("@/components/membresDeMenage.vue").default,
    checkMenage: require("@/components/groupes/checkMenage.vue").default,
  },
  methods: {
    ...mapActions({
      GetMembresDuGroupe: "Membres/GetMembresDuGroupe",
      GetMembresDuGroupeInactifs: "Membres/GetMembresDuGroupeInactifs",
      GetMenagesDuGroupe: "Menages/GetMenagesDuGroupe",
      deleteMembreStore: "Membres/deleteMembre",
      GetMenagesDuSuperviseur: "Menages/GetMenagesDuSuperviseur",
      generateMenages: "Utils/generateMenages",
      GetDetailsGroupe: "Groupes/SetItemById",
      GetMenagesDuSuperviseur: "Menages/GetMenagesDuSuperviseur",
      GetGroupesDeSuperviseur: "Groupes/GetGroupesDeSuperviseur",
      UpdateMembreDansAutresCollections:
        "Membres/UpdateMembreDansAutresCollections",
    }),
    showEditDialog(item) {
      this.editDialog = true;
      this.editedItem = item;
    },

    loadGenerateMenages() {
      let self = this;
      self.loading = true;
      var objet = {
        MembresDugroupe: self.MembresDugroupe2,
        groupe: self.groupe,
      };

      self.generateMenages(objet).then(() => {
        self.loading = false;
        self.GetMembresDuGroupe(self.$route.params.id);
        self.GetMembresDuGroupeInactifs(self.$route.params.id);

        self.GetMenagesDuGroupe(self.$route.params.id);
        self.GetDetailsGroupe(self.$route.params.id);
        self.getDetailsAnimateur();
        var objet = {
          userId: self.groupe.responsable,
          project: self.projet,
        };
        self.GetMenagesDuSuperviseur(objet);
        self.GetGroupesDeSuperviseur(objet);
      });
    },

    repairMembre(membre) {
      const self = this;
      var modifs = {
        id_responsable: self.groupe.responsable,
        nom_responsable: self.groupe.nom_responsable,
      };
      var ref = this.$firebase.firestore().collection("membres").doc(membre.id);

      ref
        .set(modifs, { merge: true })
        .then(function () {
          console.log("membre successfully repaired!");

          /** update presencesFormationsGroupes */
          const presencesFormationsGroupes = self.$firebase
            .firestore()
            .collection("presencesFormationsGroupes");
          presencesFormationsGroupes
            .where("membres_id_membre", "==", membre.id)
            .get()
            .then((snapshots) => {
              console.log(
                "Presences Formations De groupe successfully repaired!"
              );
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  presencesFormationsGroupes
                    .doc(snap.id)
                    .set(modifs, { merge: true });
                });
              } else {
                console.log("no snap presencesFormationsGroupes");
              }
            });
          /** End update presencesFormationsGroupes */

          /** update presencesDotationsGroupes */
          const presencesDotationsGroupes = self.$firebase
            .firestore()
            .collection("presencesDotationsGroupes");
          presencesDotationsGroupes
            .where("membres_id_membre", "==", membre.id)
            .get()
            .then((snapshots) => {
              console.log(
                "Presences Dotations De groupe successfully repaired!"
              );
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  presencesDotationsGroupes
                    .doc(snap.id)
                    .set(modifs, { merge: true });
                });
              } else {
                console.log("no snap presencesDotationsGroupes");
              }
            });
          /** End update presencesDotationsGroupes */

          /** update fiches */
          const fiches = self.$firebase.firestore().collection("fiches");
          fiches
            .where("membres_id_membre", "==", membre.id)
            .get()
            .then((snapshots) => {
              console.log("fiches successfully repaired!");
              if (snapshots.size > 0) {
                snapshots.forEach((snap) => {
                  fiches.doc(snap.id).set(modifs, { merge: true });
                });
              } else {
                console.log("no snap fiches");
              }
            });
          /** End update fiches */

          self.GetMembresDuGroupe(membre.id_groupe);
          self.GetMembresDuGroupeInactifs(membre.id_groupe);
        })
        .catch(function (error) {
          console.error("Error repairing document: ", error);
          self.GetMembresDuGroupe(membre.id_groupe);
          self.GetMembresDuGroupeInactifs(membre.id_groupe);
        });
    },
    repairTousLesMembredugroupe() {
      let self = this;
      this.$confirm(
        "Faites attention à ce que au moins un membre soit corrompu avant de lancer cette opération. Voulez-vous continuer?"
      ).then((res) => {
        if (res) {
          self.MembresDugroupe.forEach((membre) => {
            self.repairMembre(membre);
          });
        }
      });
    },
    gotoAnimateur() {
      let self = this;
      let idAnimateur = self.groupe.responsable;

      var docRef = this.$firebase
        .firestore()
        .collection("users")
        .doc(idAnimateur);

      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            self.detailsAnimateur = doc.data();
            var item = self.detailsAnimateur;
            item.id = doc.data().uid;
            this.$router.push({
              name: "Users-id",
              params: { item },
            });
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    },
    getDetailsAnimateur() {
      let self = this;
      let idAnimateur = self.groupe.responsable;

      var docRef = this.$firebase
        .firestore()
        .collection("users")
        .doc(idAnimateur);

      docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            self.detailsAnimateur = doc.data();
            var item = self.detailsAnimateur;
            item.id = doc.data().uid;
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch((error) => {
          console.log("Error getting document:", error);
        });
    },
    closeDialog() {
      this.editDialog = false;
      this.code_menage_selected = false;
    },

    //effacer si pas de membre
    cleanMenages(idMenage) {
      var result = [];
      var ref = this.$firebase.firestore().collection("membres");

      ref
        .where("code_menage", "==", idMenage)
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            result.push({
              ...doc.data(),
              id: doc.id,
            });
          });
        })
        .catch((error) => {
          console.log("Error getting documents: ", error);
        });

      //si pas de membres avec ce code supprimer  ce ménage

      if (result.length < 1) {
        console.log("suppresion du ménage");
        this.$firebase
          .firestore()
          .collection("newMenages")
          .doc(idMenage)
          .delete()
          .then(() => {
            console.log("Ménage successfully deleted!");
          })
          .catch((error) => {
            console.error("Error removing document: ", error);
          });
      }
    },

    updateMembre() {
      const self = this;
      var luser = {
        nom: this.editedItem.nom,
        annee_naissance: this.editedItem.annee_naissance,
        sexe: this.editedItem.sexe,
        actif_dans_groupe: this.editedItem.actif_dans_groupe,
      };

      if (this.code_menage_selected) {
        this.cleanMenages(this.editedItem.code_menage);
        luser.code_menage = this.code_menage_selected;
      }

      if (this.editedItem.actif_dans_groupe === 0) {
        //this.cleanMenages(this.editedItem.code_menage);
      }

      console.log(luser);

      var ref = this.$firebase
        .firestore()
        .collection("membres")
        .doc(this.editedItem.id);
      ref
        .set(luser, { merge: true })
        .then(function () {
          console.log("membre successfully updated!");
          var objet = { userId: self.editedItem.id, data: luser };
          self.UpdateMembreDansAutresCollections(objet);
          self.code_menage_selected = false;
          self.editDialog = false;
          self.GetMembresDuGroupe(self.editedItem.id_groupe);
        })
        .catch(function (error) {
          console.error("Error updating document: ", error);
          self.GetMembresDuGroupe(self.editedItem.id_groupe);
          self.GetMembresDuGroupeInactifs(self.editedItem.id_groupe);

          self.editDialog = false;
        });
    },
    getSexe(sexe) {
      if (sexe == "1") {
        return "Masculin";
      } else {
        return "Féminin";
      }
    },
    calculate_age(dob) {
      var diff_ms = Date.now() - dob.getTime();
      var age_dt = new Date(diff_ms);

      return Math.abs(age_dt.getUTCFullYear() - 1970);
    },
    deleteMembre(item) {
      let self = this;
      this.$confirm(
        "Voulez vous vraiment supprimer ce membre <strong> " +
          item.nom +
          " </strong> ainsi que toutes ces activités dans la base?"
      ).then((res) => {
        if (res) {
          this.deleteMembreStore(item.id);
          this.GetMembresDuGroupe(self.$route.params.id);
          this.GetMembresDuGroupeInactifs(self.$route.params.id);
        }
      });
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
      groupe: (state) => state.Groupes.itemById,
      MenagesDuSuperviseur: (state) => state.Menages.MenagesDuSuperviseur,
      MembresDugroupe: (state) => state.Membres.MembresDuGroupe,
      MembresDugroupe2: (state) => state.Membres.MembresDuGroupe2,
      MembresDuGroupeInactifs: (state) => state.Membres.MembresDuGroupeInactifs,
      MembresDuGroupeInactifs2: (state) =>
        state.Membres.MembresDuGroupeInactifs2,

      ParcoursEffectif: (state) => state.ParcoursEffectif.ParcoursEffectif,
      FormationsDeGroupe: (state) =>
        state.FormationsDeGroupe.FormationsDeGroupe,
      DotationsDeGroupe: (state) => state.DotationsDeGroupe.DotationsDeGroupe,
      Campagnes: (state) => state.Campagnes.Campagnes,
      campagneActive: (state) => state.Campagnes.campagneActive,
      projet: function (state) {
        return _.filter(state.Projets.projets, {
          id: this.$route.query.idProjet,
        })[0];
      },

      menages: function (state) {
        var menagesFiltered = [];

        state.Menages.MenagesDuGroupe.forEach(function (menage) {
          //countmembres
          var membresDuMenage = _.filter(state.Membres.MembresDuGroupe, {
            code_menage: menage.id,
          });
          //si le ménage contient au moins un membre
          if (membresDuMenage.length > 0) {
            menagesFiltered.push(menage);
          }
        });

        return menagesFiltered;
      },
    }),
  },
};
</script>

<style scoped>
.flex-table {
  display: grid;
  padding: 10px;
  border-bottom: 1px #ccc solid;
}
</style>
